var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKcs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#23AF91",
    d: "m10.208 12l3.877 3.997l2.452-2.52a1.1 1.1 0 0 1 1.567 0a1.175 1.175 0 0 1 0 1.613l-3.232 3.33a1.106 1.106 0 0 1-1.568 0l-4.732-4.8v2.85c.008.61-.462 1.128-1.072 1.14c-.613-.008-1.08-.527-1.071-1.14V7.53c0-.63.456-1.14 1.071-1.14c.608 0 1.072.51 1.072 1.14v2.85l4.733-4.8a1.106 1.106 0 0 1 1.567 0l3.224 3.33a1.173 1.173 0 0 1 0 1.612a1.097 1.097 0 0 1-1.56 0l-2.451-2.52zm3.884-1.14c.607 0 1.102.51 1.102 1.14s-.495 1.14-1.102 1.14s-1.11-.51-1.11-1.14s.495-1.14 1.11-1.14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKcs);
export default __webpack_public_path__ + "static/media/kcs.e9628cf05d4b0921ccaaf0ebaaac0920.svg";
export { ForwardRef as ReactComponent };